export function isNullOrEmpty(value) {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === "string") {
    return value.trim() === "";
  }

  if (typeof value === "object") {
    if (Array.isArray(value)) {
      return value.length === 0; // Check for empty array
    }
    // For plain objects, check if they have any own properties
    return Object.keys(value).length === 0;
  }

  return false;
}
